import { useContext, useEffect, useState } from 'react';
import AppForm from '../../../../global/components/forms/appForms/AppForm';
import { dynListTypes, gEnums, listTypes } from '../../../../global/enums/globalEnums';
import { newPropEditItem } from '../../../../global/viewSettings/helpers/settingsHelpers';
import { propDefaults } from '../../../../global/viewSettings/settingsProps/settingsAll';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { CreateSportsSeasonContext } from '../CreateSeason';
import { useCreateSportsSeason } from 'projectSpecific/sports/useHelpers/useCreateSeasonal';

export const _seasonFormTypes = {
  currentSeason: 'currentSeason',
  seasonNew: 'seasonNew',
  seasonStart: 'seasonStart',
  currentYear: 'currentYear',
}

const SeasonDetailsForm = (props) => {

  const _asat = gEnums.availableSubActionTypes
  const npei = newPropEditItem

  const { seasonFormType, subActionType } = props

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { sportsSeason_info, details_info } = sportsSeason_state ?? {}
  const { details: details_sport } = details_info ?? {}

  // createSportsSeasonContext 
  const { getCurrent, ammendSeasonalItem } = useCreateSportsSeason()
  const { sportsSeason_selected, selectedItems, mediaSeason } = getCurrent()
  const { year: latestSeason } = selectedItems ?? {}
  const { seasonals } = sportsSeason_selected ?? {}
  const { details: sportsDetails } = seasonals ?? {}


  const _sportsDetails_create = mediaSeason || sportsDetails

  const [appFormItems, setAppFormItems] = useState()
  const [currentDetails, setCurrentDetails] = useState()
  const [formData, setFormData] = useState({})

  const handleLocalPropChange = (data_form) => {
    ammendSeasonalItem({ key: 'details', data: data_form })
  }

  const handle_parentData = (d) => {
    setFormData(d)
    handleLocalPropChange(d)
  }

  // const form_handlers = { handleFormDataChange_local: handleLocalPropChange }

  const getDetailsFormProps = {
    currentSeason: {
      // playoffQualityCount: npei('playoffQualityCount', gEnums.formItemTypes.slider, null, null, null, { ...propDefaults(4, 1, 6).numbers }),
      showMatchesRemainingCount: npei('showMatchesRemainingCount', gEnums.formItemTypes.slider, null, null, null, { ...propDefaults(4, 1, 6).numbers }),
      rankingsMax: npei('rankingsMax', gEnums.formItemTypes.slider, null, null, null, { ...propDefaults(10, 1, 16).numbers }),
      surveyIsActive: npei('surveyIsActive', gEnums.formItemTypes.checkbox),
      ignoreHistory: npei('ignoreHistory', gEnums.formItemTypes.checkbox),
      ignoreRankings: npei('ignoreRankings', gEnums.formItemTypes.checkbox),
      ignoreTwitter: npei('ignoreTwitter', gEnums.formItemTypes.checkbox),
      ignoreRss: npei('ignoreRss', gEnums.formItemTypes.checkbox),
      sportsScoringAuthType: npei('sportsScoringAuthType', gEnums.formItemTypes.select, listTypes.sportsScoringAuthTypes, null, null, { breakBefore: 'Scoring' }),
    },
    seasonNew: {
      year: npei('latestSeason'),
      defaultFromLastSeason: npei('defaultFromLastSeason', gEnums.formItemTypes.checkbox),
      defaultSectionsFromLastSeason: npei('defaultSectionsFromLastSeason', gEnums.formItemTypes.checkbox),
      useMediaSeasonBump: npei('useMediaSeasonBump', gEnums.formItemTypes.checkbox),
    },
    currentYear: {
      latestSeason: npei('latestSeason'),
    },
    seasonStart: {
      seasonStartDate: npei('seasonStartDate'),
      seasonEndDate: npei('seasonEndDate'),
      firstPracticeDate: npei('firstPracticeDate'),
      firstPlayDate: npei('firstPlayDate'),
      committeeMeetingDate: npei('committeeMeetingDate'),
      playoffStartDate: npei('playoffStartDate'),
      championshipDate: npei('championshipDate'),
    }
  }

  useEffect(() => {
    switch (subActionType) {
      case _asat.createSeason:
        setCurrentDetails(_sportsDetails_create)
        setFormData(_sportsDetails_create ? _sportsDetails_create : {})
        break;
      default:
        const cd = {
          latestSeason: latestSeason,
          ...details_sport,
        }
        setFormData(cd)
        setCurrentDetails(cd)
    }
    // }
    // eslint-disable-next-line 
  }, [_sportsDetails_create, seasonFormType, subActionType]);

  useEffect(() => {
    let _appFormItems = getDetailsFormProps[seasonFormType];
    setAppFormItems(_appFormItems)
    // eslint-disable-next-line 
  }, [currentDetails]);

  const form_google = () => <AppForm
    appFormItems={appFormItems}
    data_parent={formData}
    handleUpdateParentData={handle_parentData}
  />

  return appFormItems ? form_google() : <div></div>

}

export default SeasonDetailsForm